<template>
  <div class="cookies">
    <p>
      The responses given by Mira are AI-generated and may not be accurate at
      all times.
    </p>
    <p>
      We use cookies to ensure that we give you the best experience on our
      website. If you continue to use this site we will assume that you are
      happy with it.
      <Button class="btn btn-white" @click="$emit('click')">Ok</Button>
    </p>
  </div>
</template>
<script setup>
defineEmits(["click"]);
</script>
<style lang="scss" scoped>
.cookies {
  height: fit-content;
  width: fit-content;
  position: fixed;
  bottom: 1rem;
  left: 1rem;
  z-index: 999;
  background-color: rgb(34 34 34);
  padding: 1rem;
  width: 350px;
  font-family: $theme-font;
  color: white;
  clear: both;
  @include respond-below(sm) {
    width: 90%;
    padding: 1.5rem;
    left: 50%;
    transform: translateX(-50%);
  }
  p {
    line-height: 24.68px;
    font-size: 14px;
    @include respond-below(sm) {
      font-size: 13px;
    }
    &:first-child {
      margin-bottom: 10px;
    }
  }

  .btn {
    font-family: $theme-font;
    border: 1px solid white;
    float: right;
    margin-top: 0.6rem;
  }
}
</style>
